<h2 mat-dialog-title class="">{{data?.title}}</h2>
<mat-dialog-content>
    <ng-container *ngIf="data.mode !== 'delete'; else deleteMode">
        <div class="row mb-3 p-3 w-100">
            <form [formGroup]="form" class="row g-3">
                <div class="col-md-12 mb-3">
                    <label for="name" class="form-label">Nombre</label><label class="text-danger">*</label>
                    <input type="text" id="name" class="form-control" formControlName="name" />
                    <app-form-errors [controlName]="form.controls['name']"></app-form-errors>
                </div>
            </form>
        </div>
    </ng-container>
    <ng-template #deleteMode>
        <div class="">
            <div class="">
                <h5>¿Seguro que quieres eliminar?</h5>
            </div>
        </div>
    </ng-template>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button class="btn btn-primary btn-lg me-3" (click)="Accept()">{{data.mode === 'delete' ? 'Eliminar' : 'Guardar'}}</button>
    <button mat-button class="btn btn-danger btn-lg" (click)="closeDialog()">Cancelar</button>
</mat-dialog-actions>